module.exports = __webpack_public_path__ + "static/img/img-zhuanl.41c08bc6.jpg";